import React from 'react';
import { SvgIcon } from '../SvgIcon/SvgIcon.esm.js';

const PageLastIcon = ({ ...props }) => {
    return (React.createElement(SvgIcon, { ...props, viewBox: "0 0 11 11" },
        React.createElement("path", { d: "M7.00001 5.14638L2.00009 0.14646C1.80482 -0.0488001 1.48824 -0.0488299 1.29298 0.14643L0.58602 0.85339C0.39076 1.04866 0.39076 1.36524 0.58602 1.5605L4.52544 5.49992L0.58602 9.43934C0.39076 9.63461 0.39076 9.95119 0.58602 10.1465L1.29298 10.8534C1.48825 11.0487 1.80483 11.0487 2.00009 10.8534L7.00001 5.85349C7.19527 5.65822 7.19527 5.34164 7.00001 5.14638Z" }),
        React.createElement("path", { d: "M9.00001 9.99994V0.999939C9.00001 0.723799 9.22387 0.499939 9.50001 0.499939H10.5C10.7762 0.499939 11 0.723799 11 0.999939V9.99994C11 10.2761 10.7762 10.4999 10.5 10.4999H9.50001C9.22387 10.4999 9.00001 10.2761 9.00001 9.99994Z" })));
};

export { PageLastIcon };
//# sourceMappingURL=PageLastIcon.esm.js.map
